import { useState } from "react";

import styles from "../styles/RichSelect.module.css";

/**
 * Round icon with graceful fallback to the first two characters of the
 * symbol when the image is missing, fails to load, or no URL was supplied.
 *
 * Why a component: catalog `logoURI`s come from LI.FI's CDN and occasionally
 * 404 (renamed assets, missing logos for obscure tokens). A broken img
 * tag is uglier than initials.
 */
export interface TokenIconProps {
  readonly logoURI?: string;
  readonly symbol: string;
  readonly size?: "trigger" | "item";
}

export function TokenIcon({
  logoURI,
  symbol,
  size = "trigger",
}: TokenIconProps): React.JSX.Element {
  const [errored, setErrored] = useState(false);
  const wrapper = size === "trigger" ? styles.triggerIcon : styles.itemIcon;
  const initials = symbol.slice(0, 2).toUpperCase();

  if (logoURI === undefined || logoURI === "" || errored) {
    return (
      <span className={wrapper}>
        <span className={styles.iconFallback} aria-hidden>
          {initials}
        </span>
      </span>
    );
  }

  return (
    <span className={wrapper}>
      <img
        src={logoURI}
        alt=""
        onError={() => setErrored(true)}
        loading="lazy"
        decoding="async"
      />
    </span>
  );
}
